import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustMetricsBar from './components/TrustMetricsBar';
import CategoryGrid from './components/CategoryGrid';
import SeoContentSection from './components/SeoContentSection';
import ArticleGridSection from './components/ArticleGridSection';
import TrustSection from './components/TrustSection';
import TrendingShowcase from './components/TrendingShowcase';
import Footer from './components/Footer';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'pandabuy.bar',
  url: 'https://pandabuy.bar/',
  description: 'The ultimate PandabuySpreadsheet hub for curated fashion finds and shopping lists.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://pandabuy.bar/?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <TrustMetricsBar />
        <CategoryGrid />
        <SeoContentSection />
        <ArticleGridSection />
        <TrustSection />
        <TrendingShowcase />
      </main>
      <Footer />
    </>
  );
}